(() => {
  const closePopup = (popup) => {
    if (!popup) return;
    popup.hidden = true;
    document.documentElement.classList.remove('laia-tool-popup-open');
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-laia-tool-popup-open]');
    if (opener) {
      const popup = document.getElementById(opener.dataset.laiaToolPopupOpen);
      if (!popup) return;
      popup.hidden = false;
      document.documentElement.classList.add('laia-tool-popup-open');
      popup.querySelector('[data-laia-tool-popup-close]')?.focus();
      return;
    }
    const closer = event.target.closest('[data-laia-tool-popup-close]');
    if (closer) {
      closePopup(closer.closest('[data-laia-tool-popup]'));
      return;
    }
    const copyButton = event.target.closest('[data-laia-tool-copy]');
    if (copyButton) {
      const code = copyButton.closest('.laia-tool-popup__code-row')?.querySelector('[data-laia-tool-code]')?.textContent.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = copyButton.dataset.copiedLabel || 'Copied!';
        window.setTimeout(() => { copyButton.textContent = copyButton.dataset.copyLabel || 'Copy code'; }, 1800);
      } catch (_) {}
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup(document.querySelector('[data-laia-tool-popup]:not([hidden])'));
  });
})();
